import React from 'react';
import SupportForm from 'services/support';
import { Button } from 'components/ui/button';
import { Icon } from 'components/ui/icon';

const NoDataAvailable = (): JSX.Element => {
  return (
    <div className="flex flex-col justify-center items-center gap-3 h-[436px]">
      <div className="flex p-4 items-center gap-2 rounded-full bg-gray-blue-1">
        <div className="flex p-6 items-start gap-2 rounded-full bg-gray-blue-3">
          <Icon
            name="search"
            className="text-gray-blue-60"
            size={40}
          />
        </div>
      </div>
      <div className="mt-6 mb-6 text-center">
        <div className="text-gray-blue-80 text-base font-semibold leading-6">
          No Application found linked to your store
        </div>
        <div className="text-gray-blue-70 text-sm font-normal leading-5 text-center">
          Please contact support incase of queries.
        </div>
      </div>
      <Button type="button" onClick={SupportForm.openForm}>
        Contact support
      </Button>
    </div>
  );
};

export default NoDataAvailable;
